import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {fetchInstructorCourses} from "../../../services/operations/courseDetailsAPI";
import { IoIosArrowForward } from "react-icons/io";
import CourseTable from './Instructor Courses/CourseTable';
import {setCourse} from "../../../slices/courseSlice"

function MyCourses(props) {

    const {token} = useSelector((state)=>state.auth);
    const navigate = useNavigate();
    const [courses,setCourses] = useState([]);
    const [time,setTime] = useState([]);

    useEffect(()=>{
        const fetchCourses = async () => {
            const result = await fetchInstructorCourses(token);
            // function fetches all the courses for the instructor
            let answer = [];
            if(result)
            {
                setCourses(result);
                for (let index = 0; index < result.length; index++) {
                    
                    const element = result[index].courseContent;
                    for (let i = 0; i < element.length; i++) {
                        const subsections = element[i].subSection;
                        let sum = 0;
                        for(let j = 0;j<subsections.length;j++)
                        {
                            sum += parseInt(subsections[i]?.timeDuration);
                            // console.log("Subsection:",subsections[i]?.timeDuration)
                        }
                        answer.push(sum);
                    }
                    // console.log("Element",element);
                    // const value = element.reduce((acc,curr)=>acc + curr,0);
                    // answer.push(value);
                }
            }
            setTime(answer);
            // console.log("Result: ",result)
            // console.log("Answer: ",answer);
        }
        fetchCourses();
    },[])

    return (
        <div>
            <div className='flex justify-between w-[100%]'>
                <p className='text-richblack-50 text-2xl'>My Courses</p>
                <button className='flex gap-x-2 rounded-md items-center bg-yellow-25 text-richblack-900 py-2 px-4' onClick={()=>navigate("/dashboard/add-course")}>Add Course <IoIosArrowForward /></button>
            </div>
            
            {courses && <CourseTable courses={courses} setCourse={setCourse} time={time}/>}

        </div>
    );
}

export default MyCourses;